import { render } from "./SpiceRack.vue?vue&type=template&id=20839a64&scoped=true"
import script from "./SpiceRack.vue?vue&type=script&lang=js"
export * from "./SpiceRack.vue?vue&type=script&lang=js"

import "./SpiceRack.vue?vue&type=style&index=0&id=20839a64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20839a64"]])

export default __exports__